<template>

  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">{{ $t(title) }}</div>
        <div class="card-body">

          <div class="row">

            <div class="form-group col-md-1">
              <label for="numberInput">{{ $t('address.form.number') }}{{ required ? '*': '' }}</label>
              <input v-model.trim="address.number" v-validate="required ? 'required': ''" maxlength="10" name="number" type="text" class="form-control"
                id="numberInput" :data-vv-as="$t('address.form.number')" v-bind:placeholder="$t('address.form.number')"  />
              <span class="text-danger" v-if="errors.has('number')">{{ errors.first('number') }}</span>
            </div>

            <div class="form-group col-md-6">
              <label for="addressInput">{{ $t('address.form.street') }}{{ required ? '*': '' }}</label>
              <input v-model.trim="address.street" v-validate="required ? 'required': ''" maxlength="255" name="street" type="text" class="form-control"
                id="streetInput" :data-vv-as="$t('address.form.street')" v-bind:placeholder="$t('address.form.street')"  />
              <span class="text-danger" v-if="errors.has('street')">{{ errors.first('street') }}</span>
            </div>

            <div class="form-group col-md-1">
              <label for="appartmentInput">{{ $t('address.form.app') }}</label>
              <input v-model.trim="address.app" name="appartment" type="text" maxlength="10" class="form-control" id="appartmentInput"
                v-bind:placeholder="$t('address.form.app')"  />
            </div>

            <div class="form-group col-md-4">
              <label for="cityInput">{{ $t('address.form.city') }}{{ required ? '*': '' }}</label>
              <input v-model.trim="address.city" v-validate="required ? 'required': ''" maxlength="40" name="city" type="text" class="form-control" id="cityInput"
                :data-vv-as="$t('address.form.city')" v-bind:placeholder="$t('address.form.city')"  />
              <span class="text-danger" v-if="errors.has('city')">{{ errors.first('city') }}</span>
            </div>
          </div>

          <div class="row">
            
            <div class="form-group col-md-3">
              <label for="regionInput">{{ $t('address.form.region') }}{{ required ? '*': '' }}</label>
              <input type="hidden" :data-vv-as="$t('address.form.region')" name="regions_validate" v-model="regions_validate" v-validate="'required'" />

              <select v-model="address.region" v-validate="required ? 'required': ''" class="form-control" id="regionInput" v-bind:placeholder="$t('address.form.region')">
                <option v-for="s in regions" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span class="text-danger" v-if="errors.has('regions_validate')">{{ errors.first('regions_validate') }}</span>
            </div>

            <div class="form-group col-md-3">
              <label for="postalCodeInput">{{ $t('address.form.postalCode') }}{{ required ? '*': '' }}</label>
              <input v-model.trim="address.postalCode" v-validate="required ? 'required': ''" maxlength="20" name="postalCode" type="text" class="form-control"
                id="postalCodeInput" :data-vv-as="$t('address.form.postalCode')" v-bind:placeholder="$t('address.form.postalCode')"  />
              <span class="text-danger" v-if="errors.has('postalCode')">{{ errors.first('postalCode') }}</span>
            </div>
            
            <div class="form-group col-md-3">
              <label for="stateInput">{{ $t('address.form.state') }}{{ required ? '*': '' }}</label>
              <input v-model.trim="address.state" v-validate="'required'" maxlength="80" name="state" type="text" class="form-control"
                id="stateInput" :data-vv-as="$t('address.form.state')" v-bind:placeholder="$t('address.form.state')"  />
              <span class="text-danger" v-if="errors.has('state')">{{ errors.first('state') }}</span>
            </div>

            <div class="form-group col-md-3">
              <label for="countryInput">{{ $t('address.form.country') }}{{ required ? '*': '' }}</label>
              <input v-model.trim="address.country" v-validate="required ? 'required': ''" maxlength="80" name="country" type="text" class="form-control"
                id="countryInput" :data-vv-as="$t('address.form.country')" v-bind:placeholder="$t('address.form.country')"  />
              <span class="text-danger" v-if="errors.has('country')">{{ errors.first('country') }}</span>
            </div>

          </div>
          
        </div>
      </div>

    </div>
  </div>

</template>


<script>
import {AddressServiceClient, AddressDto} from '../shared/service-clients/service-clients'
import ServiceFactory from '../shared/service-clients/serviceClientFactory'
import CrudMixin from '../shared/Mixin/CrudMixin'

export default {
  name: 'AddressComponent',
  mixins: [CrudMixin],
  props: {
    address: {
      type: AddressDto,
    },
    required: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'address.title',
    },
  },
  data() {
    return {
      regions: [],
    }
  },
  inject: ['$validator'],
  mounted: function() {
    this.fetchData()
    this.setMode()

    if (this.address.country === undefined) {
      this.address.country = 'Canada'
    }

    if (this.address.state === undefined) {
      this.address.state = 'QC'
    }
  },
  computed: {
    regions_validate: function() {
      return this.required ? this.address.region : 'notrequired'
    },
  },
  methods: {
    fetchData: function() {
      let service = ServiceFactory.create(AddressServiceClient)

      let getRegions = service.getRegions()
      let self = this

      getRegions
        .then(res => {
          self.regions = res
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Address.vue